import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  launchModal() {		
    window.setTimeout(function() {
        this.closeModal();
    }, 3000);
      
    this.openModal();
  }

  openModal() {
      console.log("open Modal");
      let theModal = document.getElementById("theModal");
    
      theModal.style.opacity = '60';
      theModal.style.pointerEvents = "auto";
  }

  closeModal() {
      var theModal = document.getElementById("theModal");
    
      theModal.style.opacity = '0';
      theModal.style.pointerEvents = "none";
  }    

}
